// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__Y6RiG","calendarButtons":"ClockData_calendarButtons__VTiwJ"};